// extracted by mini-css-extract-plugin
module.exports = {"root":"Header-root-679b074143d16304f2df8a607120a15f"};